export type Dict<T> = {
    [key: string]: T;
};

export const isSafePathSegment = (value: unknown): value is string =>
    typeof value === "string" && /^[A-Za-z0-9_-]+$/.test(value);

export const getHostname = (url: string): string | null => {
    try {
        const { hostname } = new URL(url);
        return hostname;
    } catch (e) {
        return null;
    }
};

export const getSearchParams = (url: string): Dict<string> | null => {
    try {
        const { searchParams } = new URL(url);
        const params = Object.fromEntries(searchParams);
        return params;
    } catch (e) {
        return null;
    }
};
